import { render, staticRenderFns } from "./InputEntities.vue?vue&type=template&id=9628cfa8"
import script from "./InputEntities.vue?vue&type=script&lang=js"
export * from "./InputEntities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports